export const localizationStringsDe = {
  scan_the_front_side: 'Scannen Sie die Vorderseite des Dokuments',
  scan_data_page: 'Scannen Sie die Datenseite des Dokuments',
  scan_top_page: 'Scannen Sie die obere Seite',
  scan_left_page: 'Scannen Sie die linke Seite',
  scan_right_page: 'Scannen Sie die rechte Seite',
  flip_document: 'Drehen Sie das Dokument um',
  wrong_top: 'Bewegen Sie zur oberen Seite',
  wrong_left: 'Bewegen Sie zur linken Seite',
  wrong_right: 'Bewegen Sie zur rechten Seite',
  flip_to_back_side: 'Drehen Sie zur Rückseite',
  move_top: 'Bewegen Sie sich zur oberen Seite',
  move_left: 'Bewegen Sie sich zur linken Seite',
  move_right: 'Bewegen Sie sich zur rechten Seite',
  scan_the_back_side: 'Scannen Sie die Rückseite des Dokuments',
  scan_the_barcode: 'Scannen Sie den Barcode',
  move_closer: 'Halten Sie das Dokument näher',
  move_farther: 'Halten Sie das Dokument weiter weg',
  camera_angle_too_steep: 'Halten Sie das Dokument parallel zum Telefon',
  face_photo_not_fully_visible:
    'Halten Sie das Gesichtsfoto vollständig sichtbar',
  document_too_close_to_edge: 'Halten Sie das Dokument vom Rand entfernt',
  blur_detected: 'Halten Sie Dokument und Telefon ruhig',
  glare_detected:
    'Neigen oder bewegen Sie das Dokument, um Reflexionen zu vermeiden',
  occluded: 'Halten Sie das Dokument vollständig sichtbar',
  too_dark: 'Begeben Sie sich an einen helleren Ort',
  too_bright: 'Begeben Sie sich an einen weniger hellen Ort',
  scan_unsuccessful: 'Scan fehlgeschlagen',
  scan_unsuccessful_details:
    'Das Dokument konnte nicht gelesen werden. Bitte versuchen Sie es erneut.',
  error_occurred: 'Fehler aufgetreten',
  sdk_initialization_error: 'Fehler bei der Initialisierung des SDK',
  sdk_initialization_error_details:
    'Es ist ein Fehler aufgetreten, beim initialisieren des BlinkID-SDK.',
  camera_error: 'Kamerafehler',
  camera_permission_denied:
    'Kamerazugriff verweigert. Bitte Kamerazugriff erlauben und erneut versuchen.',
  scan_time_exceeded: 'Scan-Zeit überschritten',
  scan_taking_longer_hint:
    'Der Scanvorgang dauert länger als erwartet. Stellen Sie sicher, dass das Dokument gut beleuchtet, scharf und korrekt im Rahmen der Kamera positioniert ist.',
  document_not_supported: 'Dokument nicht unterstützt',
  try_different_document: 'Ein anderes Dokument ausprobieren',
  document_not_supported_hint:
    'Das Dokument, das Sie scannen möchten, wird von dieser Anwendung nicht unterstützt. Versuchen Sie, ein anderes Dokument zu scannen.',
  document_not_recognized: 'Dokument nicht erkannt',
  document_not_recognized_details:
    'Scannen Sie die Vorderseite eines unterstützten Dokuments.',
  document_filtered: 'Dokument nicht akzeptiert',
  label_from: 'von',
  onboarding_modal_title: 'Halten Sie alle Details sichtbar',
  onboarding_modal_details:
    'Stellen Sie sicher, dass das Dokument gut beleuchtet ist. Alle Felder müssen auf dem Bildschirm sichtbar sein.',
  onboarding_modal_btn: 'Scan starten',
  help_modal_title_1: 'Halten Sie alle Felder sichtbar',
  help_modal_details_1:
    'Bedecken Sie keine Teile des Dokuments mit dem Finger, einschließlich der unteren Zeilen. Achten Sie auf Hologrammreflexionen.',
  help_modal_title_2: 'Vermeiden Sie direktes Licht',
  help_modal_details_2:
    'Direktes Licht kann Reflexionen erzeugen, die das Dokument unlesbar machen. Wenn die Daten unlesbar sind, kann die Kamera sie nicht erfassen.',
  help_modal_title_3: 'Bleiben Sie während des Scans ruhig',
  help_modal_details_3:
    'Versuchen Sie, das Telefon und das Dokument während des Scans ruhig zu halten.',
  help_modal_back_btn: 'Zurück',
  help_modal_next_btn: 'Weiter',
  help_modal_done_btn: 'Fertig',
  help_aria_label: 'Hilfe',
  help_tooltip: 'Hilfe benötigen?',
  alert_retry_btn: 'Erneut versuchen',
  alert_cancel_btn: 'Abbrechen',
  screen_photo_error:
    'Bitte fotografieren Sie keinen Bildschirm ab. Verwenden Sie das Originaldokument.',
  glare_photo_error:
    'Starke Lichtreflexe erkannt. Bitte vermeiden Sie direktes Licht oder Blendeffekte.',
  copy_or_screenshot_photo_error:
    'Das Dokument scheint eine Kopie oder ein Screenshot zu sein. Bitte verwenden Sie das Originaldokument.',
  invalid_document_photo_error:
    'Das Dokument ist unvollständig, ungültig oder enthält widersprüchliche Angaben. Bitte überprüfen Sie es.',
  front_side_blur_or_glare_error:
    'Die Vorderseite ist unscharf, hat Blendung oder wurde nicht korrekt erkannt.',
  both_sides_required_error:
    'Für diesen Dokumenttyp müssen beide Seiten hochgeladen werden. Bitte laden Sie die zweite Seite hoch.',
  invalid_file_type:
    'Ungültiger Dateityp. Bitte laden Sie ein JPG, JPEG oder PNG hoch.',
  file_too_large_error: 'Datei ist zu groß. Maximal 5 MB erlaubt.',
  scan_successful: 'Scan erfolgreich.',
} as const;
